import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useCallback, useImperativeHandle, useRef } from 'react';
import { StepperButton } from './stepper-button';
import { cn } from '../../../utils';
export const UncontrolledInput = forwardRef(({ name, type, error, ...props }, ref) => {
    const inputRef = useRef(null);
    useImperativeHandle(ref, () => inputRef.current);
    const handleIncrement = useCallback(() => {
        if (!inputRef.current) {
            return;
        }
        const currentValue = inputRef.current.value;
        const step = props.step ? parseFloat(props.step.toString()) : 1;
        const newValue = parseFloat(currentValue || '0') + step;
        if (props.max && newValue > parseFloat(props.max.toString())) {
            return;
        }
        const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
        nativeInputValueSetter.call(inputRef.current, newValue.toString());
        inputRef.current.dispatchEvent(new Event('input', { bubbles: true }));
    }, [props.max, props.step]);
    const handleDecrement = useCallback(() => {
        if (!inputRef.current) {
            return;
        }
        const currentValue = inputRef.current.value;
        const step = props.step ? parseFloat(props.step.toString()) : 1;
        const newValue = parseFloat(currentValue || '0') - step;
        if (props.min && newValue < parseFloat(props.min.toString())) {
            return;
        }
        const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
        nativeInputValueSetter.call(inputRef.current, newValue.toString());
        inputRef.current.dispatchEvent(new Event('input', { bubbles: true }));
    }, [props.min, props.step]);
    return (_jsxs("div", { className: cn('relative flex rounded-surface border border-border-subtle overflow-hidden', 'focus-within:ring-2 focus-within:ring-border-focus focus-within:ring-offset-0', {
            'border-danger focus-within:outline-danger': error,
        }, props.className), children: [_jsx("input", { ...props, ref: inputRef, type: type, id: name, name: name, className: cn('flex-1', 'px-stack min-h-12 text-body-sm text-fg-muted', 'placeholder:text-body-sm placeholder:text-fg-disabled', '[appearance:textfield]', '[&::-webkit-outer-spin-button]:appearance-none', '[&::-webkit-inner-spin-button]:appearance-none', 'focus:outline-none', 'border-0', {
                    'text-danger placeholder:text-danger/60': error,
                    'cursor-not-allowed': props.disabled,
                }) }), type === 'number' && (_jsxs("div", { className: "flex flex-col self-stretch border-l border-border divide-y divide-border", children: [_jsx(StepperButton, { direction: "up", onClick: handleIncrement }), _jsx(StepperButton, { direction: "down", onClick: handleDecrement })] }))] }));
});
UncontrolledInput.displayName = 'UncontrolledInput';
